const styles = {
  card: {
    flex: 1,
    textAlign: 'center',
  },
  scroll: {
    height: '60vh',
    overflowY: 'auto',
    '&::-webkit-scrollbar': { display: 'none' },
    msOverflowStyle: 'none',
    scrollbarWidth: 'none',
  },
  linear: {
    flex: 1,
    mr: 1,
  },
  deleteIcon: {
    fontSize: 18,
  },
  backgroundEmb: {
    backgroundColor: '#22267B' + 14,
  },

  qrcode: {
    fontSize: 150,
  },
  hideInput: {
    position: 'absolute',
    opacity: 0,
    pointerEvents: 'none',
  },
  btn: {
    alignSelf: 'start',
  },
  headerContainer: {
    marginBottom: '.5em',
    display: 'flex',
    alignItems: 'start',
    justifyContent: 'space-between',
  },
  backBtn: {
    '&&': {
      marginRight: '.5em',
    },
  },
  title: {
    flex: 1,
    padding: '1px 0',
  },
  drawer: {
    width: { xs: '100%', sm: '75%', md: '50%', lg: '30%' },
    backgroundColor: 'primary.white',
    display: 'flex',
  },
  drawerContainer: {
    paddingTop: '3vh',
    height: '90vh',
    overflowY: 'auto',
    '&::-webkit-scrollbar': { display: 'none' },
    msOverflowStyle: 'none',
    scrollbarWidth: 'none',
  },
  formControl: {
    width: '100%',
    maxWidth: 300,
    textAlign: 'start',
  },
};

export default styles;
